import axios from "axios";

const baseURL = 'http://18.134.133.59:4000/api/v1.0';

export const fetchReportByDay = async () =>{
    const { data } = await axios.get(`${baseURL}/home/2022-03-07`);
    const flaggedEntry = await axios.get(`${baseURL}/thresholds/time`);
    const flagged = flaggedEntry.data.map(report=>{
        return {
            id: report.id,
            evaluatorCode: report.Evaluator_code,
            branchID: report.Branch_id,
            type: report.assessment_type,
            submissionTime: report.timeSubmitted,
        }
    })
    const evaluatorEntries = data.allAssessment.map(entry => {
        return {
            id: entry.evaluator_assessment_id,
            evaluator_code: entry.evaluator_access_code,
            type: entry.type,
            branch_id: entry.campaign_assessment_branch_id,
            score: entry.totalScore
        }
    })

    const dateOfReports= data.allDaysOfAssessment;
    const evaluatorsOfDay= data.numberOfEvalutor;
    const bankAssessed= data.bankAssessed;
    const regionCover= data.regionCover;
    const staffAssessed= data.staffAssessed;
    const group= data.group;

    return {
        entries: evaluatorEntries,
        flaggedEntries: flagged,
        dates: dateOfReports,
        totalEvaluators: evaluatorsOfDay,
        bankAssessed,
        staffAssessed,
        regionCover,
        group
    };
};